var _defs, _rect, _rect2, _rect3, _rect4, _path, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventry(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    id: "icon",
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 19,
    y: 24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 26,
    y: 24
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 19,
    y: 17
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 26,
    y: 17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17,24H4V10H28v5h2V10a2.0023,2.0023,0,0,0-2-2H22V4a2.0023,2.0023,0,0,0-2-2H12a2.002,2.002,0,0,0-2,2V8H4a2.002,2.002,0,0,0-2,2V24a2.0023,2.0023,0,0,0,2,2H17ZM12,4h8V8H12Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    "data-name": "<Transparent Rectangle>",
    height: 32,
    id: "_Transparent_Rectangle_",
    width: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventry);
export default __webpack_public_path__ + "static/media/inventry.bf28dc5ac9738ee92d748cf0d06a1b50.svg";
export { ForwardRef as ReactComponent };